// extracted by mini-css-extract-plugin
module.exports = {"primaryItem":"_8ae6c455","primaryLink":"_93067340","primaryImage":"_6219f047","productItems":"_ad33aec1","shimmerLoadingBackground":"_98fcdfa1"};